<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span class="condition_item_lable">排序方式：</span>
            <el-radio-group
              v-model="listQuery.Sorting"
              size="mini"
              @change="sortRadioChange"
            >
              <el-radio-button
                :label="sortOrderItem.Sorting"
                v-for="(sortOrderItem, sortOrderItemIndex) in sortOrderItems"
                :key="'sortOrder' + sortOrderItemIndex"
              >
                {{ sortOrderItem.SortingText }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button type="primary" @click="exportData()">
              导出数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="invoiceInfoItems"
        style="width: 100%"
        stripe
        border
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column
          property="InvoiceTitle"
          label="单位名称"
          min-width="260"
        >
        </el-table-column>
        <el-table-column
          property="MemberSort"
          label="单位排序"
          min-width="75"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <div v-if="!scope.row.MemberSort">--</div>
              <div v-if="scope.row.MemberSort">{{ scope.row.MemberSort }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开票信息" min-width="400">
          <template slot-scope="scope">
            <div>
              <div>名称：{{ scope.row.InvoiceTitle }}</div>
              <div>纳税人识别号：{{ scope.row.InvoiceCode }}</div>
              <div>
                地址、电话：
                {{ scope.row.CompanyAddress }}
                <span v-if="scope.row.CompanyLandline">，</span>
                {{ scope.row.CompanyLandline }}
              </div>
              <div>
                开户行及账号：{{ scope.row.Bank }}
                <span v-if="scope.row.BankAccount">，</span>
                {{ scope.row.BankAccount }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发票类型" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.InvoiceType === 0">普通发票</span>
            <span v-if="scope.row.InvoiceType === 1">增值税专用发票</span>
          </template>
        </el-table-column>
        <el-table-column label="开票需求" min-width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.InvoicingRequirements }}</span>
          </template>
        </el-table-column>
        <el-table-column property="MailingAddress" label="邮箱" min-width="150">
        </el-table-column>
        <el-table-column
          property="Contacts"
          label="联系人"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="Telephone"
          label="联系电话"
          width="110"
          align="center"
        >
        </el-table-column>
        <el-table-column property="Remarks" label="备注" min-width="120">
        </el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteInvoiceInfo(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import invoiceManagerApi from '../../../api/vote/invoiceManager'
export default {
  name: 'InvoiceManager',
  components: {

  },
  data () {
    return {
      meetingId: null,
      tableLoading: true,
      invoiceInfoItems: [],
      listTotalCount: 0,
      currentPage: 1,
      sortOrderItems: [{ Sorting: 'CreateTime', SortingText: '提交时间' }, { Sorting: 'MemberSort', SortingText: '单位序号' }],
      listQuery: {
        MeetingId: null,
        maxResultCount: 10,
        skipCount: 0,
        Sorting: 'CreateTime'
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['meetingInfo'],
  methods: {
    getInvoiceInfoList: function () {
      this.tableLoading = true
      invoiceManagerApi.getInvoiceInfoList(this.listQuery).then(data => {
        this.invoiceInfoItems = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    sortRadioChange: function (val) {
      this.currentPage = 1
      this.listQuery.skipCount = (this.currentPage - 1) * this.listQuery.maxResultCount
      this.getInvoiceInfoList()
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getInvoiceInfoList()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getInvoiceInfoList()
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    deleteInvoiceInfo: function (item) {
      this.$confirm('确认删除该条数据吗？单位名称：“' + item.InvoiceTitle + '”', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        invoiceManagerApi.deleteInvoiceInfo({
          id: item.Id
        }).then(data => {
          openLoading.close()
          this.getInvoiceInfoList()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    exportData: function () {
      const openLoading = this.openLoading('正在导出…')
      invoiceManagerApi.exportInvoiceInfoList({
        MeetingId: this.$route.params.mid,
        Sorting: this.listQuery.Sorting
      }).then(data => {
        if (!data) {
          return
        }
        const fileName = this.meetingInfo.MeetingName + '发票信息统计表'

        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    init: function () {
      this.meetingId = this.$route.params.mid
      this.listQuery.MeetingId = this.$route.params.mid
      this.getInvoiceInfoList()
    }
  },
  computed: {

  },
  created () {
    this.init()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
